import { Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "../i18n";
import { buttonVariants } from "./ui/button";

export function DocsShell() {
  const { t } = useTranslation();
  const chapterClass = buttonVariants({ variant: "ghost", className: "justify-start data-[status=active]:bg-accent data-[status=active]:text-accent-foreground" });
  return <div className="page mx-auto grid w-full max-w-7xl gap-6 lg:grid-cols-[180px_minmax(0,1fr)]">
    <aside className="min-w-0 self-start lg:sticky lg:top-24">
      <nav aria-label={t("documentation.navigation")} className="grid gap-3 text-sm">
        <strong className="text-foreground">{t("nav.documentation")}</strong>
        <div className="flex flex-wrap gap-1 lg:flex-col">
          <Link to="/docs/errors" className={chapterClass}>{t("nav.errorDocs")}</Link>
          <Link to="/docs/usage" className={chapterClass}>{t("nav.usageDocs")}</Link>
        </div>
      </nav>
    </aside>
    <div className="min-w-0"><Outlet /></div>
  </div>;
}
